export default __webpack_public_path__ + "static/media/clio-rs-colour-3.30c383cc.jpg";